import { render } from "./TextSkeleton.vue?vue&type=template&id=979e4e64"
import script from "./TextSkeleton.vue?vue&type=script&lang=js"
export * from "./TextSkeleton.vue?vue&type=script&lang=js"

import "./TextSkeleton.vue?vue&type=style&index=0&id=979e4e64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__